import React from 'react'
import { Paper, Typography, ButtonBase } from '@mui/material'
import withStyles from '@mui/styles/withStyles';
import { Link } from 'react-router-dom'
import { ChevronRight } from 'genesis-suite/icons'

const style = theme => ({
    wrapper: { height: '226px', border: 'solid 2px #e0e0e0' },
    body: { height: '75%', padding: '20px' },
    footer: {
        height: '25%',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: '10px',
        paddingRight: '20px',
        borderTop: '2px solid #e0e0e0',
        '&:hover': { backgroundColor: '#e9e9e9' },
    },
    footerText: { fontWeight: 'bold' },
    link: { textDecoration: 'none', color: theme.palette.text.primary },
})

const HomeCard = ({ title, content, footer, routePath, classes }) => {
    return (
        <Paper elevation={0} className={classes.wrapper}>
            <div className={classes.body}>
                <Typography variant="h5" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body1">{content}</Typography>
            </div>

            <Link to={routePath} className={classes.link}>
                <ButtonBase className={classes.footer}>
                    <Typography variant="body1" className={classes.footerText}>
                        {footer}
                    </Typography>
                    <ChevronRight />
                </ButtonBase>
            </Link>
        </Paper>
    )
}

export default withStyles(style)(HomeCard)
